<template>
  <div class="first-type-select">
    <span v-for="(first, index) in list" :key="first.id || index" class="item" :class="{active: value===first.id && list2.length}"
      :style="value===first.id ? {marginBottom: `${list2Height}px`} : {}">
      <span @click.prevent.stop="handleSelect(first)">
        <el-radio :value="value" :disabled="first.isDisabled||isDisabledAll" :label="first.id">{{first.name}}</el-radio>
      </span>
      <div class="child-view" v-if="value===first.id && list2.length" ref="child-view">
        <span v-for="(second, index) in list2" :key="second.id || index" class="second-item" @click="handleSelect2(second)">
          <el-radio :value="value2" :label="second.id">{{second.name}}</el-radio>
        </span>
        <slot />
      </div>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list2Height: 0
    }
  },
  props: {
    list: Array,
    list2: {
      type: Array,
      default: () => []
    },
    value: String,
    value2: String,
    isDisabledAll: { // 禁用全部
      type: Boolean,
      default: false
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.list2Height = 0
      }
    },
    list2: {
      immediate: true,
      handler(list) {
        if (list.length) {
          setTimeout(() => {
            try {
              this.list2Height = this.$refs['child-view'][0].offsetHeight + 14
            } catch (err) {
              console.error(err)
            }
          }, 100)
        } else {
          this.list2Height = 0
        }
      }
    }
  },
  mounted() {
    // this.error = 0
    // this.$interval = setInterval(() => {
    //   try {
    //     this.list2Height = this.$refs['child-view'][0].offsetHeight + 14
    //     this.error = 0
    //   } catch (err) {
    //     this.error++
    //     if (this.error > 3) {
    //       clearInterval(this.$interval)
    //     }
    //   }
    // }, 500)
  },

  methods: {
    handleSelect(item) {
      if (item.isDisabled||this.isDisabledAll) return
      if (this.value !== item.id && !item.isDisabled) {
        this.$emit('input', item.id)
        this.$emit('change', item.id)
      }
    },
    handleSelect2(item) {
      if (this.value2 !== item.id) {
        this.$emit('input2', item.id)
        this.$emit('change2', item.id)
      }
    }
  }
}
</script>

<style lang="scss">
.first-type-select {
  .el-radio__label {
    padding-left: 4px;
    font-size: 12px;
  }
}
</style>

<style lang="scss" scoped>
.first-type-select {
  position: relative;
  .item {
    display: inline-block;
    &.active:after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      position: absolute;
      border-top: 1px solid rgba(209, 222, 240);
      border-left: 1px solid rgba(209, 222, 240);
      @include border-color('lighter');
      background: rgba(245, 248, 255);
      @include bg-color('main');
      z-index: 6;
      transform: rotate(45deg);
      margin-left: 19px;
      margin-top: 5px;
    }

    .child-view {
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      position: absolute;
      left: 0;
      z-index: 5;
      background: rgba(245, 248, 255);
      border: 1px solid rgba(209, 222, 240);
      @include border-color('lighter');
      @include bg-color('main');
      margin-top: 10px;
    }

    .second-item {
      display: inline-block;
      margin: 6px 0;
    }
  }
}
</style>
